import ProductBatchCard from './ProductBatchCard';

export default ProductBatchCard;
